import DecisionTreeDiagram from '@/pages/Candidate/view/utils/DecisionTreeDiagram';
import ColorKeyPerMatch from '@/pages/Candidate/view/utils/DecisionTreeDiagram/nodes/ColorKeyPerMatch';
import {
  CloseIconStyled,
  CloseButtonWrapper,
  ContentWrapper,
  CopyToClipboardStyled,
  DynamicText,
  HeadingContent,
  Modal,
} from '@/pages/Candidate/view/modals/DecisionTreeModal/styled';
import { DecisionTreeModalProps } from '@/pages/Candidate/view/modals/DecisionTreeModal/types';
import useController from '@/pages/Candidate/view/modals/DecisionTreeModal/useController';

const DecisionTreeModal = (props: DecisionTreeModalProps) => {
  const { isOpen, data, onCloseButton } = props || {};
  const { notify, reportToken, headingRows } = useController(props);

  if (!isOpen) return null;

  return (
    <Modal isOpen={isOpen}>
      <ContentWrapper>
        <CloseButtonWrapper>
          <CloseIconStyled onClick={onCloseButton} />
        </CloseButtonWrapper>

        <HeadingContent>
          <h2>
            Criminal Algorithm v6 Decision Tree for TURN ID{' '}
            <CopyToClipboardStyled onCopy={() => notify('TURN ID copied to clipboard')} text={reportToken}>
              <span>{reportToken}</span>
            </CopyToClipboardStyled>
          </h2>

          {headingRows
            .filter((row) => row.value != null)
            .map(({ label, renderValue, value }) => (
              <h4 key={label}>
                {label}: {renderValue ?? <DynamicText>{value}</DynamicText>}
              </h4>
            ))}
        </HeadingContent>

        <DecisionTreeDiagram data={data} />
        <ColorKeyPerMatch />
      </ContentWrapper>
    </Modal>
  );
};

export default DecisionTreeModal;
